import { LocationEntity } from '@peritasai/repository';
import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useReleaseToDeconService } from '../services/release-to-decon.service';
import { ReleaseToDeconStep } from '../types/release-to-decon';

type UseReleaseToDeconDataResult = {
  step: ReleaseToDeconStep;
  setStep: Dispatch<SetStateAction<ReleaseToDeconStep>>;
  locations: LocationEntity[];
  visibleLocations: LocationEntity[];
  showAllLocations: boolean;
  setShowAllLocations: Dispatch<SetStateAction<boolean>>;
  loadLocations: () => Promise<void>;
};

export const useReleaseToDeconData = (): UseReleaseToDeconDataResult => {
  const [step, setStep] = useState<ReleaseToDeconStep>(
    ReleaseToDeconStep.LOADING_LOCATIONS
  );
  const [locations, setLocations] = useState<LocationEntity[]>([]);
  const [showAllLocations, setShowAllLocations] = useState(false);

  const releaseToDeconService = useReleaseToDeconService();
  //breaks useEffect dependcy loop
  const releaseToDeconServiceRef = useRef(releaseToDeconService);
  releaseToDeconServiceRef.current = releaseToDeconService;

  const visibleLocations = useMemo(
    () => (showAllLocations ? locations : locations.slice(0, 4)),
    [locations, showAllLocations]
  );

  const loadLocations = useCallback(async () => {
    setStep(ReleaseToDeconStep.LOADING_LOCATIONS);
    try {
      const data = await releaseToDeconServiceRef.current.getLocations();
      if (data.length === 0) {
        setStep(ReleaseToDeconStep.ERROR_LOCATIONS);
        return;
      }
      setLocations(data);
      setShowAllLocations(false);
      setStep(ReleaseToDeconStep.SELECT_LOCATION);
    } catch (error) {
      console.error('Failed to load sidehub locations', error);
      setStep(ReleaseToDeconStep.ERROR_LOCATIONS);
    }
  }, []);

  useEffect(() => {
    void loadLocations();
  }, [loadLocations]);

  return {
    step,
    setStep,
    locations,
    visibleLocations,
    showAllLocations,
    setShowAllLocations,
    loadLocations,
  };
};
